<template>
  <vs-popup id="popupSearchEmployee" class="overflow-hidden" title="종사자 검색" :active.sync="showPopup" >
    <div class="h-full flex flex-col">
      <div class="grid xl:flex gap-2 items-end border-bottom p-4" >
        <div class="grid grid-cols-1 xl:grid-cols-12 gap-4">
          <div class="col-span-8 grid grid-cols-1 xl:grid-cols-2 gap-4 ">
            <div style="display: grid; grid-template-columns: auto 1fr; align-items: center">
              <span class="text-left" style="width: 114px;">사업장명</span>
              <field-selector v-model="selectedFieldId" @select="handleFieldSelect" />
            </div>
            <div style="display: grid; grid-template-columns: auto 1fr; align-items: center">
              <span class="text-left" style="width: 114px;">부서명</span>
              <company-selector :fieldId="selectedFieldId === 0 ? null : selectedFieldId" v-model="selectedCompanyId" @click.stop @select="handlerCompanySelect" />
            </div>
          </div>
          <div class="col-span-8 grid grid-cols-1 xl:grid-cols-2 gap-4 ">
            <div style="display: grid; grid-template-columns: auto 1fr; align-items: center">
              <span class="text-left" style="width: 114px;">검색조건</span>
              <vs-select class="w-full" v-model="filterType" :placeholder="'전체'" autocomplete>
                <vs-select-item v-for="selectData in filterTypeOptions" :key="selectData.value" :text="selectData.label" :value="selectData.value" />
              </vs-select>
            </div>
            <div>
              <search-nav-item-keyword class="w-full" :view-label="false" placeholder="검색" v-model="search.keyword" @keyup-event="handleClickSearch" />
            </div>
          </div>
        </div>
        <div class="ml-auto">
          <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
        </div>
      </div>
      <div class="p-4">
        <vs-select autocomplete v-model="page.perPage" @input="handleClickSearch">
          <vs-select-item v-for="i in [10, 25, 50, 100]" :text="`${i}개씩 보기`" :value="i"/>
        </vs-select>
      </div>

      <div class="flex-1 overflow-y-auto">
        <div class="w-full">
          <vs-table
            ref="table"
            stripe
            sst
            :max-items="page.perPage"
            :data="employeeList"
            noDataText="데이터가 없습니다"
            @sort="handleSort"
          >
            <template slot="thead">
              <vs-th style="min-width: 40px; width: 40px;"><vs-checkbox :value="allCheck" @click.native="onCheckAll" /></vs-th>
              <vs-th style="min-width: 60px; width: 60px" sort-key="id"><span class="w-full text-center">No.</span></vs-th>
              <vs-th style="min-width: 100px; width: 9%" sort-key="팀명"><span class="w-full text-center">팀명</span></vs-th>
              <vs-th style="min-width: 100px; width: 9%" sort-key="사번"><span class="w-full text-center">ID(사번)</span></vs-th>
              <vs-th style="min-width: 200px; width: 9%" sort-key="업무분야"><span class="w-full text-center">업무분야</span></vs-th>
              <vs-th style="min-width: 100px; width: 9%" sort-key="직종"><span class="w-full text-center">직종</span></vs-th>
              <vs-th style="min-width: 100px; width: 9%;" class="cursor-default" title="암호화 데이터 정렬이 불가합니다."><span class="w-full text-center">성별</span></vs-th>
              <vs-th style="min-width: 100px; width: 9%" class="cursor-default" title="암호화 데이터 정렬이 불가합니다."><span class="w-full text-center">성명</span></vs-th>
              <vs-th style="min-width: 120px; width: 9%" sort-key="입사일"><span class="w-full text-center">입사일</span></vs-th>
              <vs-th style="min-width: 120px; width: 9%" sort-key="종료예정일"><span class="w-full text-center">종료 예정일</span></vs-th>
              <vs-th style="min-width: 140px; width: 9%" class="cursor-default" title="암호화 데이터 정렬이 불가합니다."><span class="w-full text-center">핸드폰</span></vs-th>
              <vs-th style="min-width: 120px; width: 9%" sort-key="종료일"><span class="w-full text-center">종료일</span></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="employee" :key="index" v-for="(employee, index) in data">
                <vs-td class="text-center"><vs-checkbox :vs-value="employee.id" v-model="checkEmployeeIds" @change="() => onCheckEmployee(employee)" /></vs-td>
                <vs-td class="text-center">{{ employee.id }}</vs-td>
                <vs-td class="text-center">{{ /*부서명*/ employee.company.com_name }}</vs-td>
                <vs-td class="text-center">{{ /*사번*/ employee.employee_id }}</vs-td>
                <vs-td class="text-center">{{ /*구분*/ employee.job_category }}</vs-td>
                <vs-td class="text-center">{{ /*직종*/ employee.employment_type }}</vs-td>
                <vs-td class="text-center">{{ /*성별*/ employee.gender }}</vs-td>
                <vs-td class="text-center">{{ /*성명*/ employee.full_name }}</vs-td>
                <vs-td class="text-center">{{ /*최종 입사일*/ employee.hire_date }}</vs-td>
                <vs-td class="text-center">{{ /*종료 예정일*/ employee.exp_retirement_date }}</vs-td>
                <vs-td class="text-center">{{ /*연락처*/ employee.contact_number }}</vs-td>
                <vs-td class="text-center">{{ /*종료일*/ employee.retirement_date }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage"></k-pagination>
        </div>
      </div>

      <div class="p-4 pt-0 flex items-center justify-end">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="showPopup = false">닫기 </vs-button>
        <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
import FileUploader from "@/components/FileUploader.vue";
import AddressField from "@/components/AddressField.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword.vue";
export default {
  name: "PopupSearchEmployee",
  components: {
    SearchNavItemKeyword,
    CompanySelector,
    FieldSelector,
    AddressField,
    FileUploader,
    KPagination,
  },
  props: {
    value: Boolean,
    // 팝업이 열릴 때, 선택된 ID가 있을 경우 해당 ID를 선택한 상태로 팝업을 열기 위한 값
    initSelectedEmployees: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    projectList() {
      return this.$store.state.project.projectListInfo.data;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    employeeList() {
      if (!this.apiResponseData) return [];

      if (this.apiResponseData.data) {
        return this.apiResponseData.data;
      } else {
        return [];
      }
    },
    allCheck() {
      return this.employeeList.reduce((acc, cur) => {
        return acc && this.checkEmployeeIds.includes(cur.id);
      }, true);
    },
  },
  data() {
    return {
      showPopup: this.value,

      checkEmployee: [],
      checkEmployeeIds: [],

      selectedField: {},
      selectedFieldId: 0,
      selectedCompany: {},
      selectedCompanyId: 0,
      filterType: "",
      filterTypeOptions: [
        {
          label: "전체",
          value: "",
        },
        {
          label: "ID(사번)",
          value: "employee_id",
        },
        {
          label: "부서",
          value: "com_name",
        },
        {
          label: "구분",
          value: "job_category",
        },
        {
          label: "직종",
          value: "employment_type",
        },
        {
          label: "성별",
          value: "gender",
        },
        {
          label: "연락처(마지막 4자리)",
          value: "contact_number",
        },
      ],

      // 현재 검색되어 반환된 리스트
      apiResponseData: [],

      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 50,
        orderBy: '',
        orderDirection: '',
      },

      // 겅색
      search: {
        keyword: "", // 검색어
      },
    };
  },
  watch: {
    value(data) {
      this.showPopup = data;
      if (data) {
        this.loadEmployeeList();

        this.checkEmployee = this.initSelectedEmployees;
        this.checkEmployeeIds = this.initSelectedEmployees.map((item) => item.id);
      }
    },
    initSelectedEmployees(data) {
      this.checkEmployee = data;
      this.checkEmployeeIds = data.map((item) => item.id);
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },
  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },
  methods: {
    handleSort(key, orderBy) {
      const sortKey = {
        'id': 'id',
        '팀명': 'com_name',
        '사번': 'employee_id',
        '업무분야': 'job_category',
        '직종': 'employment_type',
        '성별': '',
        '성명': '',
        '입사일': 'hire_date',
        '종료예정일': 'exp_retirement_date',
        '핸드폰': '',
        '종료일': 'retirement_date',
      }
      if (!sortKey[key]) return;

      this.page.orderBy = sortKey[key];
      this.page.orderDirection = orderBy;
      this.loadEmployeeList();
    },
    onCheckAll() {
      if (this.allCheck) {
        const empListIds = this.employeeList.map((item) => item.id);
        this.checkEmployeeIds = this.checkEmployeeIds.filter((item) => !empListIds.includes(item));
        this.checkEmployee = this.checkEmployee.filter((item) => !empListIds.includes(item.id));
      } else {
        this.checkEmployeeIds = this.employeeList.map((item) => item.id);
        this.checkEmployee = this.employeeList;
      }
    },
    onCheckEmployee(data) {
      if (this.checkEmployeeIds.includes(data.id)) this.checkEmployee.push(data);
      else this.checkEmployee = this.checkEmployee.filter((item) => item.id !== data.id);
    },
    async loadEmployeeList() {
      const page = this.page.current;
      const perPage = this.page.perPage;
      const projectId = this.projectId;

      const payload = {
        projectId,
        page,
        perPage,
      };
      if (this.selectedFieldId > 0) {
        payload.field_ids = [this.selectedFieldId];
      }
      if (this.selectedCompanyId > 0) {
        payload.company_id = this.selectedCompanyId;
      }

      // 선택한 필터링 타입에 맞게 검색어를 전달한다
      switch (this.filterType) {
      case "":
        payload.keyword = this.search.keyword;
        break;
      case "employee_id":
        payload.employee_id = this.search.keyword;
        break;
      case "com_name":
        payload.com_name = this.search.keyword;
        break;
      case "job_category":
        payload.job_category = this.search.keyword;
        break;
      case "employment_type":
        payload.employment_type = this.search.keyword;
        break;
      case "gender":
        payload.gender = this.search.keyword;
        break;
      case "contact_number":
        payload.contact_number = this.search.keyword;
        break;
      }

      if (this.page.orderBy) {
        payload.order_by = this.page.orderBy;
        payload.order_direction = this.page.orderDirection;
      }

      if (!this.page.orderDirection) {
        payload.order_by = 'id';
        payload.order_direction = 'desc';
      }

      this.apiResponseData = await this.$store.dispatch("employee/LOAD_EMPLOYEE_LIST", payload);

      if (this.apiResponseData) {
        this.page.current = this.apiResponseData.current_page;
        this.page.perPage = this.apiResponseData.per_page;
        this.page.lastPage = this.apiResponseData.last_page;
      }
    },

    handleClickSearch() {
      this.page.current = 1;
      this.loadEmployeeList();
    },

    handleChangePage(page) {
      this.page.current = page;
      this.loadEmployeeList();
    },

    handleClickSelect() {
      this.$emit("input", false);
      this.$emit("handleClickSelect", this.checkEmployee);
    },

    // 사업장이 선택됐을 대
    handleFieldSelect(fieldData) {
      this.selectedField = fieldData;
      this.loadEmployeeList();
    },
    // 부서가 선택됐을 때
    handlerCompanySelect(companyData) {
      this.selectedCompany = companyData;
      this.selectedCompanyId = companyData.id;
      this.loadEmployeeList();
    },
  },
};
</script>

<style>
#popupSearchEmployee .vs-popup {
  width: 1600px !important;
  max-width: 80% !important;
  max-height: 80% !important;

  height: calc(80% - 40px) !important;
}

#popupSearchEmployee > .vs-popup > .vs-popup--content {
  width: 100%;
  height: calc(100% - 40px) !important;
  padding: 0;
  margin: 0;
}

</style>

<style scoped lang="scss">
.table-layout {
  border: 1px solid #cdcdcd;
}

.table-layout .trow {
  border-bottom: 1px solid #cdcdcd;
}

.table-layout .tcol {
  border-right: 1px solid #cdcdcd;
}

.vs-con-table.stripe .tr-values.active {
  background: rgb(102, 112, 203) !important;
  color: #fff;
  font-weight: bold;
}

.red {
  color: #ea5455;
}
.cursor-default::v-deep {
  cursor: default !important;
  .vs-table-text {
    cursor: default !important;
  }
}
</style>
